import React, { useState } from 'react'
import PropTypes from 'prop-types'

import cn from 'classnames'
import { Box, Button, FormLabel, Paper } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import ExpandSecondary from '@scoir/brand-icons/dist/ExpandSecondary'
import { Info } from '@scoir/tooltips'
import { ToggleBox } from 'material/ToggleBox'

const useStyles = makeStyles((theme) => ({
  button: {
    display: 'flex',
    borderRadius: '4px',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
  },
}))

export const ToggleableSection = ({ children, hasError, title, subTitle, info }) => {
  const [isCollapsed, setIsCollapsed] = useState(true)
  const classes = useStyles()
  return (
    <Box my={1}>
      <Paper variant="outlined">
        <Button
          fullWidth
          aria-label={`Toggle ${title} Section: ${isCollapsed ? 'Collapsed' : 'Expanded'}. ${info}`}
          aria-pressed={!isCollapsed}
          className={classes.button}
          onClick={() => setIsCollapsed(!isCollapsed)}
          endIcon={<ExpandSecondary className={cn('expand-icon', { inverted: !isCollapsed })} />}
        >
          <Box
            component={FormLabel}
            error={hasError}
            display="flex"
            alignItems="center"
          >
            {title} <span className="sub-title">{subTitle}</span>
            {info && (
              <Box mx={1}>
                <Info
                  outlinedIcon
                  inheritColor
                  aria-label={info}
                >
                  {info}
                </Info>
              </Box>
            )}
          </Box>
        </Button>
        <ToggleBox collapsed={isCollapsed}>
          <Box
            width="100%"
            px={2}
            pb={1}
          >
            {children}
          </Box>
        </ToggleBox>
      </Paper>
    </Box>
  )
}

ToggleableSection.propTypes = {
  children: PropTypes.any,
  hasError: PropTypes.bool,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  info: PropTypes.node,
}

export default ToggleableSection
